module.exports = __webpack_public_path__ + "img/twoGray.a0122105.png";